import { VideoEnhancerNLE } from '@/components/VideoEnhancerNLE';

const VideoEnhancerNLEPage = () => {
  return <VideoEnhancerNLE />;
};

export default VideoEnhancerNLEPage;
